import script from "./ResultScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultScreen.vue?vue&type=script&setup=true&lang=ts"

import "./ResultScreen.vue?vue&type=style&index=0&id=52f0752f&lang=scss"

const __exports__ = script;

export default __exports__